import "./AuditInput.css";
import "../pages/Landing.css";
import ToolUrlCard from "./ToolUrlCard";
import { displayUrl, toFullUrl } from "../utils/urlForm";

/**
 * mode="guest"  — anonymous quick audit (hero form on mobile, full card on desktop)
 * mode="app"    — logged-in SEO audit (PageSpeed-style card)
 */
const AuditInput = ({
  url,
  setUrl,
  onStart,
  loading,
  mode = "guest",
}) => {
  const handleGuestSubmit = (e) => {
    e.preventDefault();
    if (!loading && displayUrl(url)) onStart();
  };

  if (mode === "app") {
    return (
      <div className="audit-container audit-container--app">
        <h1 className="page-title">SEO Audit</h1>
        <p className="dashboard-lead audit-lead">
          Analyze your page for on-page SEO issues, structure, and assets.
        </p>
        <ToolUrlCard
          url={url}
          onChange={setUrl}
          onSubmit={onStart}
          buttonLabel={loading ? "Analyzing..." : "Run Audit"}
          loading={loading}
          placeholder="your-website.com"
          inputAriaLabel="Website URL for SEO audit"
        />
      </div>
    );
  }

  return (
    <div className="audit-container audit-container--guest">
      <div className="audit-onboarding">
        <h1 className="audit-title">Instant SEO Insights</h1>
        <p className="audit-subtitle">
          Run a lightning-fast on-page audit. Get a real score and prioritized recommendations immediately.
        </p>

        {/* Mobile: compact hero-style form like landing page */}
        <form className="hero-url-form audit-url-form audit-url-form--mobile" onSubmit={handleGuestSubmit}>
          <input
            className="hero-url-input"
            type="text"
            placeholder="your-website.com"
            value={displayUrl(url)}
            onChange={(e) => setUrl(toFullUrl(e.target.value))}
            disabled={loading}
            autoComplete="url"
            spellCheck={false}
            aria-label="Website URL for free audit"
          />
          <button type="submit" className="cta-primary" disabled={loading || !displayUrl(url)}>
            {loading ? "Analyzing..." : "Run Audit"}
          </button>
        </form>

        {/* Desktop: full-width card like PageSpeed */}
        <div className="audit-url-form--desktop">
          <ToolUrlCard
            url={url}
            onChange={setUrl}
            onSubmit={onStart}
            buttonLabel={loading ? "Analyzing..." : "Run Audit"}
            loading={loading}
            placeholder="your-website.com"
            inputAriaLabel="Website URL for free audit"
          />
        </div>
      </div>
    </div>
  );
};

export default AuditInput;
